import 'moment/locale/zh-cn';
import { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from '@/components/Layout';
import SiteLayout from '@/components/SiteLayout';
import routeConfig from './routeConfig';

// 不需要前置登录的页面白名单
const WHITE_PAGE_LIST = ['/', '/login', '/pricing', '/subscription-plan', '/ecosystem', '/voice-ai'];

// 使用通用站点布局（Header + Footer）的页面
const SITE_LAYOUT_PATHS = ['/', '/pricing', '/subscription-plan', '/ecosystem', '/voice-ai'];

// 独立布局页面（如登录页，不带 Header/Footer）
const STANDALONE_PATHS = ['/login'];

const createRoutes = (routeConfigList = []) => (
  routeConfigList.map(({ path, component: Component }) => (
    <Route exact key={path} path={path} element={<Component />} />
  ))
)

const Index = () => {
  const siteRoutes = routeConfig.filter(({ path }) => SITE_LAYOUT_PATHS.includes(path));
  const standaloneRoutes = routeConfig.filter(({ path }) => STANDALONE_PATHS.includes(path));
  const appRoutes = routeConfig.filter(({ path }) => !WHITE_PAGE_LIST.includes(path));

  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route element={<SiteLayout />}>
            {createRoutes(siteRoutes)}
          </Route>
          {createRoutes(standaloneRoutes)}
          <Route path="/app" element={<Layout />}>
            {createRoutes(appRoutes)}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default Index;
